import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  public readonly menuDisplayed = signal<boolean>(false);
  public readonly headerDisplayed = signal<boolean>(false);

  public showMenu(): void {
    this.menuDisplayed.set(true);
  }

  public hideMenu(): void {
    this.menuDisplayed.set(false);
  }

  public toggleMenuVisibility(): void {
    this.menuDisplayed.update(value => !value);
  }

  public showHeader(): void {
    this.headerDisplayed.set(true);
  }

  public hideHeader(): void {
    this.headerDisplayed.set(false);
  }

  public toggleHeaderVisibility(): void {
    this.headerDisplayed.update(value => !value);
  }
}
